





















































































































import { Component, Vue } from 'vue-property-decorator'
import AbpBase from '@/lib/abpbase'
import CustomForm from '@/components/custom-form/index.vue'
import PicModal from '@/components/upload/picModal.vue'
import TurnTablePrize from './turnTablePrize.vue'
import ScratchCardPrize from './scratchCardPrize.vue'
import RewardPointGameApi from '@/api/marketing/rewardPointGame/index'
@Component({
  components: {
    CustomForm,
    PicModal,
    TurnTablePrize,
    ScratchCardPrize
  }
})
export default class PromotionGame extends AbpBase {
  frequencyControl: string = 'day'
  currentTab: string = 'basicForm'
  activityId: string = ''
  ruleValidate = {
    name: [{ required: true, message: '活动标题不能为空', trigger: 'blur' }],
    beginTime: [
      {
        required: true,
        type: 'date',
        message: '请选择开始日期',
        trigger: 'change'
      }
    ],
    endTime: [
      {
        required: true,
        type: 'date',
        message: '请选择结束日期',
        trigger: 'change'
      }
    ]
  }

  ruleValidate3 = {
    imageUrl: [
      {
        validator: (rule, value, callback) => {
          if (this.formItem.showOnHomepage) {
            if (!value) {
              callback('请选择弹窗图片')
            }
          }
          callback()
        },
        trigger: 'change'
      }
    ]
  }
  ruleValidate4 = {
    activityPrizes: [
      {
        validator: (rule, value, callback) => {
          if (this.formItem.type === 0) {
            // 大转盘
            var items = value.filter(x => x.prizeType > -1 && x.name === '')
            if (items.length > 0) {
              callback('还有奖项没有设置，请检查')
            }
          } else {
            // 刮刮卡
            if (value.length <= 0) {
              callback('至少设置一个奖品')
            }
          }
          callback()
        },
        trigger: 'change'
      }
    ]
  }
  validNumber(rule, value, callback) {
    if (value <= 0) {
      callback(new Error('必须大于0'))
    }
    callback()
  }
  validTierDiscount(rule, value, callback) {
    callback()
  }
  formItem = {
    name: '',
    type: 0,
    beginTime: null,
    endTime: null,
    rule: '',
    expendPoint: 0,
    totalParticipateCount: 1,
    totalWins: 0,
    winRate: 0,
    // hitCount: 0,
    // luckSum: 1,
    published: false,
    showOnHomepage: false,
    coverImage: '',
    activityPrizes: [],
    luckyType: 1
  }
  get ruleConfigValidate() {
    return null
  }
  get computeRuleConfig() {
    return null
  }
  async mounted() {
    this.formItem.type = parseInt(this.$route.meta.promotionType)
    if (this.$route.query.id !== undefined) {
      this.activityId = this.$route.query.id.toString()
      await this.loadActivity()
    } else {
      if (this.formItem.type === 0) {
        this.formItem.activityPrizes = Array.from({ length: 9 }, (v, index) => {
          console.log('activityPrizes', index)
          return {
            prizeType: index === 4 ? -1 : 0,
            couponId: '',
            couponType: '',
            discountValue: null,
            rewardPoint: 0,
            name: '',
            pictureUrl: '',
            quantity: 0,
            winQuantity: 0,
            remainQuantity: 0,
            rate: 0,
            id: ''
          }
        })
      }
    }
  }
  async loadActivity() {
    await RewardPointGameApi.getRewardPointGame(this.activityId).then(res => {
      console.log(res)
      this.formItem = res.data
      this.formItem.beginTime = new Date(res.data.beginTime)
      this.formItem.endTime = new Date(res.data.endTime)

      this.formItem.type = parseInt(this.$route.meta.promotionType)
    })
  }
  imageUrlChange(list) {
    this.formItem.coverImage = list[0].url
  }
  save() {
    console.log(this.formItem);
    var valid1 = (this.$refs['basicForm'] as any).validate()
    var valid2 =
      (this.$refs['ruleConfigForm'] as any).rules === null
        ? new Promise(resolver => resolver(true))
        : (this.$refs['ruleConfigForm'] as any).validate()

    var valid3 = this.isVicutuProject ? (this.$refs["disseminateForm"] as any).validate() : new Promise(resolver => resolver(true));
    var valid4 = (this.$refs['prizeForm'] as any).validate()

    Promise.all([valid1, valid2, valid3, valid4]).then(values => {
      console.log('values', values)
      var index = values.findIndex(x => x === false)

      if (index > -1) {
        if (index === 0) this.currentTab = 'basicForm'
        if (index === 1) this.currentTab = 'ruleConfigForm'
        if (index === 2) this.currentTab = 'disseminateForm'
        if (index === 3) this.currentTab = 'prizeForm'
      } else {
        if (this.activityId === '') {
          RewardPointGameApi.addRewardPointGame(this.formItem).then(res => {
            console.log('add promotion activity', res)
            this.$Message.success('保存成功')
            this.$router.push({
              name:
                this.formItem.type === 0 ? 'turnTableList' : 'scratchCardList'
            })
          })
        } else {
          RewardPointGameApi.updateRewardPointGame(
            this.activityId,
            this.formItem
          ).then(res => {
            this.$Message.success('保存成功')
            this.$router.push({
              name:
                this.formItem.type === 0 ? 'turnTableList' : 'scratchCardList'
            })
          })
        }
      }
    })
  }
}
